module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"user-dashboard-resources":"Ressources"},"en":{"user-dashboard-resources":"Resources"}}')
  delete Component.options._Ctor
}
